import React from 'react';

import ClientRenderedContent from '@components/ClientRenderedContent';
import Highlight from '@components/FeedItems/Highlight';
import { event_path } from '@routes';
import { Event } from '@utils/backend-api/events';

import styles from './styles.module.scss';

const EventCard = ({ image, highlight, name, date, location, slug }: Event) => {
  return (
    <div className={styles.eventContainer}>
      <div className={styles.eventImageContainer}>
        <a href={event_path(slug)}>
          <img src={image} alt={name} />
        </a>
      </div>
      <div className={styles.eventHighlight}>
        <Highlight
          className="first-letter:capitalize"
          customPath={event_path(slug)}
          highlight={highlight}
        />
      </div>
      <a href={event_path(slug)}>
        <div className={styles.eventTitle}>{name}</div>
        <div className={styles.eventTimeDetail}>
          <ClientRenderedContent>
            {date} | {location}
          </ClientRenderedContent>
        </div>
      </a>
    </div>
  );
};

export default EventCard;
